import { LbaItemTag } from "@/components/SearchForTrainingsAndJobs/components/LbaItemTag"

export const TagCandidatureSpontanee = () => {
  return (
    <LbaItemTag color="yellow" iconClassName="fr-icon-compass-3-fill">
      CANDIDATURE SPONTANÉE
    </LbaItemTag>
  )
}
